module.exports = __webpack_public_path__ + "img/logo.56059c51.png";